module.exports = __webpack_public_path__ + "static/media/truesquare.d8f7d5cd.png";